import { Component } from '@angular/core';

@Component({
    selector: 'app-work-flow-section',
    imports: [],
    templateUrl: './work-flow-section.component.html',
    styleUrl: './work-flow-section.component.less',
})
export class WorkFlowSectionComponent {}
